import React, {Component} from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import {ContentChartStyled} from "./styled";
import { Grid, Typography} from "@material-ui/core";
import SpacerComponent from "../../../Components/SpacerComponent/SpacerComponent";
import {Chart} from "react-google-charts";
import LoadDashboard from "./LoadDashboard";

class ChartDefault extends Component {

    formatData() {

        if (this.props.data === undefined) {
            return [];
        }

        const formatData = [
            ['Data', 'Total'],
        ];

        this.props.data.forEach(function (value) {

            const arrayData = [];

            arrayData.push(value.description);
            arrayData.push(parseInt(value.count));

            formatData.push(arrayData);

        });

        return formatData;

    }

    render() {
        const { showGrid, title, elevation } = this.props; // Destructure showGrid, title, and elevation from props

        if (this.formatData().length <= 0) {
            return (
                <LoadDashboard title={title}/>
            );
        }

        const chartContent = (
            <ContentChartStyled elevation={elevation}> {/* Use the elevation prop here */}
                <Typography variant={'h6'}
                            color={'primary'}>
                    {title}
                </Typography>
                <SpacerComponent height={20}/>
                <Chart
                    width={'100%'}
                    height={300}
                    chartType="ColumnChart"
                    loader={<div>Loading Chart</div>}
                    data={this.formatData()}
                    options={{}}
                />
            </ContentChartStyled>
        );

        if (showGrid) {
            return (
                <Grid item={true}
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      xl={6}>
                    {chartContent}
                </Grid>
            );
        } else {
            return chartContent; // Render without Grid if showGrid is false
        }
    }
}

ChartDefault.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string.isRequired,
    showGrid: PropTypes.bool,
    elevation: PropTypes.number, // New propType for elevation
};

ChartDefault.defaultProps = {
    showGrid: true,
    elevation: 3, // Default value for elevation is 3
};

export default ChartDefault;